var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuandao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_110)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.43085C1 3.07326 2.90901 1.15918 5.26977 1.15918H14.0081V4.50782H5.26977C4.76159 4.50782 4.34864 4.91948 4.34864 5.43085C4.34864 5.94062 4.76189 6.35387 5.27167 6.35387H10.4664C12.8255 6.35387 14.738 8.26636 14.738 10.6255C14.738 12.9847 12.8255 14.8972 10.4664 14.8972H1.72979V11.5486H10.4664C10.9761 11.5486 11.3894 11.1353 11.3894 10.6255C11.3894 10.1158 10.9761 9.70251 10.4664 9.70251H5.27167C2.91249 9.70251 1 7.79002 1 5.43085Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.96741,
    y: 10.698,
    width: 0.558107,
    height: 5.02296,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.558107
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.171,
    y: 0.279054,
    width: 0.558107,
    height: 5.02296,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.558107
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuandao);
export default __webpack_public_path__ + "static/media/guandao.50b116bd0a68a63cc9977adb1388e848.svg";
export { ForwardRef as ReactComponent };